import { textInputData } from '../constants';
const styleOverrides = {
  root: {
    fontSize: textInputData.label.size,
    color: textInputData.label.color
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiInputLabel.js.map